/** Small formatting helpers shared across screens. */

/** Format an ISO-8601 timestamp as a short, human, locale date-time (or '—'). */
export function fmtTime(iso?: string): string {
    if (!iso) {
        return '—';
    }

    const ms = Date.parse(iso);

    if (Number.isNaN(ms)) {
        return iso;
    }

    return new Date(ms).toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}

/** Compact relative age for table cells ("2h ago", "3d ago"), or '—'. */
export function fmtRelative(iso?: string): string {
    if (!iso) {
        return '—';
    }

    const ms = Date.parse(iso);

    if (Number.isNaN(ms)) {
        return iso;
    }

    const diff = Date.now() - ms;
    const min = Math.round(diff / 60000);

    if (min < 1) {
        return 'just now';
    }
    if (min < 60) {
        return `${min}m ago`;
    }

    const hr = Math.round(min / 60);

    if (hr < 24) {
        return `${hr}h ago`;
    }

    const day = Math.round(hr / 24);

    if (day < 30) {
        return `${day}d ago`;
    }

    return new Date(ms).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}
